import {
  deletePatientMorphologyPictureEndpoint,
  getPatientMorphologyPictureEndpoint,
  getPatientMorphologyPicturesListEndpoint,
  getPatientProfilePictureEndpoint,
  postPatientMorphologyPictureEndpoint,
} from "./api/Images";

export const getPatientProfilePicture = patientId => {
  return getPatientProfilePictureEndpoint(patientId)
    .then(response => {
      return response;
    })
    .catch(error => {
      if (error.response?.status === 404) {
        return { data: null, contentType: null, notFound: true };
      }
      throw new Error(`Error fetching profile picture: ${error.message}`);
    });
};

export const getPatientMorphologyPicture = (
  patientId,
  filename,
  { signal } = {}
) => getPatientMorphologyPictureEndpoint(patientId, filename, signal);

export const getPatientMorphologyPicturesList = (patientId, signal) =>
  getPatientMorphologyPicturesListEndpoint(patientId, signal);

export const postPatientMorphologyPicture = async (
  patientId,
  file,
  filename
) => {
  return postPatientMorphologyPictureEndpoint(patientId, file, filename)
    .then(response => {
      return response;
    })
    .catch(error => {
      throw new Error(`Error fetching the image: ${error.message}`);
    });
};

export const deletePatientMorphologyPicture = async (patientId, filename) => {
  return deletePatientMorphologyPictureEndpoint(patientId, filename)
    .then(response => {
      return response;
    })
    .catch(error => {
      throw new Error(`Error deleting morphology image: ${error.message}`);
    });
};
